import axios from "axios";
import { toast } from "sonner";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { ShieldCheck, ArrowLeft } from "lucide-react";
import { API } from "@/lib/api";

const PAYPAL_STYLE = { layout: "vertical", color: "gold", shape: "pill", label: "paypal" };

function PayPalBlock({ clientId, form, onApproved }) {
  const options = { clientId, currency: "MXN", intent: "capture", locale: "es_MX", disableFunding: "card,credit" };

  const createOrder = async () => {
    const { data } = await axios.post(`${API}/paypal/orders`, form);
    return data.order_id;
  };

  const onApprove = async (data) => {
    try {
      const res = await axios.post(`${API}/paypal/orders/${data.orderID}/capture`);
      if (res.data.status === "COMPLETED") onApproved(data.orderID);
      else toast.error("El pago con PayPal no se completó. Intenta de nuevo.");
    } catch (err) {
      toast.error(err.response?.data?.detail || "El pago con PayPal no se completó.");
    }
  };

  return (
    <div className="mt-8" data-testid="paypal-section">
      <div className="flex items-center gap-4 mb-5">
        <span className="h-px flex-1" style={{ background: "var(--border)" }} />
        <span className="text-xs font-semibold uppercase tracking-[0.2em]" style={{ color: "var(--text-muted)" }}>o paga con PayPal</span>
        <span className="h-px flex-1" style={{ background: "var(--border)" }} />
      </div>
      <div className="mx-auto max-w-md" data-testid="paypal-buttons-container">
        <PayPalScriptProvider options={options}>
          <PayPalButtons fundingSource="paypal" style={PAYPAL_STYLE} createOrder={createOrder} onApprove={onApprove}
            onError={() => toast.error("Ocurrió un error con PayPal. Intenta de nuevo o usa tarjeta/OXXO.")} />
        </PayPalScriptProvider>
      </div>
    </div>
  );
}

export function PaymentStep({ step, oxxoHold, paypalClientId, form, onCancel, onPaypalApproved }) {
  return (
    <div data-testid="payment-step">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-6">
        <div className="flex items-center gap-2">
          <ShieldCheck size={20} style={{ color: "var(--mint-dark)" }} />
          <h3 className="font-display text-2xl font-bold" style={{ color: "var(--text-dark)" }}>Pago seguro — $200 MXN</h3>
        </div>
        <button onClick={onCancel} data-testid="cancel-payment-button"
          className="inline-flex items-center gap-1.5 rounded-full border px-4 py-2 text-sm font-semibold transition-colors hover:bg-[var(--bg)]"
          style={{ borderColor: "var(--border)", color: "var(--text-dark)" }}>
          <ArrowLeft size={14} /> Volver al formulario
        </button>
      </div>
      {step === "processing" && !oxxoHold && (
        <p className="mb-4 rounded-2xl p-4 text-sm font-semibold" style={{ background: "var(--mint-light)", color: "var(--mint-dark)" }} data-testid="payment-processing">
          Confirmando tu pago, un momento...
        </p>
      )}
      {oxxoHold && (
        <p className="mb-4 rounded-2xl p-4 text-sm font-semibold" style={{ background: "#FEF3C7", color: "#92400E" }} data-testid="oxxo-hold-notice">
          ¡Tu cita quedó apartada! Guarda tu ficha OXXO (también te la enviamos por correo) y paga antes de 2 días para confirmarla. Si no recibimos el pago, el horario se liberará.
        </p>
      )}
      <div id="stripe-checkout" data-testid="stripe-checkout-container" />
      {!oxxoHold && paypalClientId && <PayPalBlock clientId={paypalClientId} form={form} onApproved={onPaypalApproved} />}
    </div>
  );
}
